import PlusIcon from "@redotech/redo-icons/plus.svg";
import { AutomationForgeElementType } from "@redotech/redo-model/forge/marketing-automation-forge-types";
import { FormElementDrag } from "@redotech/redo-web/form-builder/form-element-drag";
import { Handle, Position } from "@xyflow/react";
import classNames from "classnames";
import { DropTargetMonitor, useDrop } from "react-dnd";
import * as NodeCSS from "./node.module.css";

export function DropZone(
  idFrom: string,
  elementDropped: (
    elementType: AutomationForgeElementType,
    idFrom: string,
    idTo?: string,
    conditionSide?: boolean,
    edgeId?: string,
  ) => void,
  idTo?: string,
  conditionSide?: boolean,
  isNode?: boolean,
  edgeId?: string,
) {
  const [{ isOver, canDrop }, drop] = useDrop(
    () => ({
      accept: Object.values(AutomationForgeElementType),
      drop(_item: typeof FormElementDrag, monitor) {
        elementDropped(
          monitor.getItemType() as AutomationForgeElementType,
          idFrom,
          idTo,
          conditionSide,
          edgeId,
        );
        return undefined;
      },
      collect: (monitor: DropTargetMonitor) => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      }),
    }),
    [elementDropped],
  );

  const style = isOver
    ? NodeCSS.dropNodeOver
    : canDrop
      ? NodeCSS.dropNodeValid
      : "";

  return (
    <div className={isNode ? NodeCSS.dropNode : ""} ref={drop}>
      <div
        className={classNames(
          NodeCSS.expandedDropRadius,
          isOver ? NodeCSS.expandedValid : "",
        )}
      />
      <div
        className={classNames(NodeCSS.dropCircle, style)}
        data-testid="drop-zone-icon" // could be useful to make this have an index in the future for complicated automation testing
      >
        <PlusIcon className={NodeCSS.dropCircleIcon} />
      </div>
    </div>
  );
}

export interface DropZoneNodeData {
  idFrom: string;
  idTo?: string;
  conditionSide?: boolean;
  edgeId?: string;
  elementDropped(
    elementType: AutomationForgeElementType,
    idFrom: string,
    idTo?: string,
    conditionSide?: boolean,
    edgeId?: string,
  ): void;
}

export function DropZoneNode(data: {
  id: string;
  data: DropZoneNodeData;
  selected?: boolean | undefined;
}) {
  return (
    <>
      <Handle
        className={NodeCSS.hidden}
        position={Position.Top}
        type="target"
      />
      {DropZone(
        data.data.idFrom,
        data.data.elementDropped,
        data.data.idTo,
        data.data.conditionSide,
        true,
        data.data.edgeId,
      )}
    </>
  );
}
